module.exports = __webpack_public_path__ + "static/media/faq-sub-file.244c14f1.svg";